import React from 'react'
import { Route, Routes } from 'react-router-dom'
import TagManager from 'react-gtm-module'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'styles/App.css'
import 'styles/fonts.css'

import About from 'pages/About'
import Careers from 'pages/Careers'
import Contact from 'pages/Contact'
import Customers from 'pages/Customers'
import Home from 'pages/Home'
import Plans from 'pages/Plans'
import Pricing from 'pages/Pricing'
import Services from 'pages/Services'
import Security from 'pages/Security'
import PrivacyPolicy from 'pages/PrivacyPolicy'
import Terms from 'pages/Terms'

const tagManagerArgs = {
    gtmId: 'GTM-KSF6983'
}

TagManager.initialize(tagManagerArgs)

function App() {
    return (
        <Routes>
            <Route path="/" element={<Home/>} exact />
            <Route path="/about" element={<About/>} />
            <Route path="/services" element={<Services/>} />
            <Route path="/customers" element={<Customers/>} />
            <Route path="/plans" element={<Plans/>} />
            <Route path="/cpsh-2022" element={<Pricing/>} />
            <Route path="/contact" element={<Contact/>} />
            <Route path="/success" element={<Contact/>} />
            <Route path="/careers" element={<Careers/>} />
            <Route path="/security" element={<Security/>} />
            <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
            <Route path="/terms-of-use" element={<Terms/>} />
            <Route element={<Home/>} />
        </Routes>
    )
}

export default App
